module.exports = __webpack_public_path__ + "img/max-ulichney-caldera.259248e.jpg";